'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = format;
exports.formatUtc = formatUtc;
exports.toEpochSeconds = toEpochSeconds;
exports.toUtcEpochSeconds = toUtcEpochSeconds;
exports.toEpochMilliseconds = toEpochMilliseconds;
exports.toUtcEpochMilliseconds = toUtcEpochMilliseconds;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _LangUtils = require('./LangUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function format(d, inputFormat, outputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? (0, _moment2.default)(d).format(outputFormat) : (0, _moment2.default)(d, inputFormat).format(outputFormat);
}

function formatUtc(d, inputFormat, outputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? _moment2.default.utc(d).format(outputFormat) : _moment2.default.utc(d, inputFormat).format(outputFormat);
}

function toEpochSeconds(d, inputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? (0, _moment2.default)(d).unix() : (0, _moment2.default)(d, inputFormat).unix();
}

function toUtcEpochSeconds(d, inputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? _moment2.default.utc(d).unix() : _moment2.default.utc(d, inputFormat).unix();
}

function toEpochMilliseconds(d, inputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? (0, _moment2.default)(d).valueOf() : (0, _moment2.default)(d, inputFormat).valueOf();
}

function toUtcEpochMilliseconds(d, inputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? _moment2.default.utc(d).valueOf() : _moment2.default.urc(d, inputFormat).valueOf();
}

exports.default = {
  format: format,
  formatUtc: formatUtc,
  toEpochMilliseconds: toEpochMilliseconds,
  toEpochSeconds: toEpochSeconds,
  toUtcEpochMilliseconds: toUtcEpochMilliseconds,
  toUtcEpochSeconds: toUtcEpochSeconds
};